import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExamVoucherItem } from '../models/exam-voucher';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { environment } from '../../../environments/environment';
import { RouterParamsService } from '../../shared/services/router-params.service';

@Injectable({
  providedIn: 'root',
})
export class ExamVoucherItemsEntityService extends BaseEntityService<ExamVoucherItem> {

  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, {
        singular: 'examVoucherItem',
        plural: 'examVoucherItems',
        url: 'exam-voucher-items',
      },
      routerParamsService,
      // No permissions yet: the API spec does not define the EXAM_VOUCHER_ITEM_* names
    );
    this.nameId = 'examVoucherItemId';
  }

  getByIdList(ids: number[]): Observable<ExamVoucherItem[]> {
    return this.getWithQuery({ ids: ids.join(',') });
  }
}
